export default __webpack_public_path__ + "static/cover-f64fff27de49db2ef4bb1b765f2c71ce.jpg";